import { render, staticRenderFns } from "./FacetoFace.vue?vue&type=template&id=c832b37e&scoped=true&"
import script from "./FacetoFace.vue?vue&type=script&lang=js&"
export * from "./FacetoFace.vue?vue&type=script&lang=js&"
import style0 from "./FacetoFace.vue?vue&type=style&index=0&id=c832b37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c832b37e",
  null
  
)

export default component.exports